<template>
  <q-list class="row no-wrap items-center">
    <q-item
      class="row items-center q-mr-md"
      clickable
      dense
      v-for="{ label, key, to } in menu"
      :key="key"
      :to="{
        ...to,
        query: {
          ...($route.query || {}),
          ...(to.query || {}),
        },
      }"
      active-class="admin-menu-item-active"
    >
      <span>{{ label }}</span>
    </q-item>
  </q-list>
</template>

<script>
import { getUserProfile } from "../../../api/endpoints/auth/getUserProfile";
import { roughlyToPlain } from "../../../utils/roughly-to-plain";
const menu = [
  // {
  //   label: "首页",
  //   key: "index",
  //   to: {
  //     name: "admin_index",
  //   },
  // },

  {
    label: "样本分布情况",
    key: "sample_distribute",
    to: {
      name: "sample_distribution",
    },
  },
  {
    label: "调查小组管理",
    key: "user-group",
    to: {
      name: "admin_user_group",
    },
  },
  {
    label: "调查样本管理",
    key: "sample-group",
    to: {
      name: "admin_sample_group",
    },
  },
  {
    label: "问题反馈",
    key: "feedback",
    to: {
      name: "feedback",
    },
  },
  {
    label: "质控",
    key: "quality",
    to: {
      name: "admin_quality",
    },
  },
];
export default {
  data() {
    return {
      menu,
    };
  },

  async created() {
    const profile = await getUserProfile(true);
    if (profile.roles.some((role) => role.value == "005")) {
      this.menu = roughlyToPlain(
        this.menu.filter((menu) => {
          return ["quality"].indexOf(menu.key) > -1;
        })
      );
    }
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

.admin-menu-item-active {
  background-color: #fff;
  color: $primary !important;
  box-shadow: $shadow-22;
}
</style>
